<template>
  <v-container 
    fill-height
    fluid
  >
    <v-layout
      v-if="!$apollo.loading && !_.isEmpty(whiteLabels)"
      wrap
    >
      <v-flex
        xs12
      >
        <h2>{{ $t('whitelabel.myWhiteLabels') }}</h2>
        <v-btn
          small
          class="primary btn-project mt-6"
          @click="addWhiteLabel()"
        >
          {{ $t('whitelabel.createButton') }}
        </v-btn>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-data-table
            class="text-no-wrap" 
            :headers="headers"
            :items="whiteLabels"
            :hide-default-footer="true"
            :mobile-breakpoint="900"
            :items-per-page="200"
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                v-text="header.text"
              />
            </template>
            <template v-slot:item.logo="{ item }">
              <v-avatar
                :tile="false"
                :size="50"
                :color="item.primary_color"
              >
                <v-img
                  :src="item.design ? item.design.default_theme === 'dark'
                    ? (item.design.dark_theme_logo || require('@/images/no-image.png'))
                    : (item.design.light_theme_logo || require('@/images/no-image.png')) : item.logo"
                  :lazy-src="item.logo"
                  max-width="40"
                  contain
                />
              </v-avatar>  
            </template>
            <template v-slot:item.name="{ item }">
              <b>{{ item.name }}</b>
            </template>
            <template v-slot:item.status="{ item }">
              <b 
                :class="item.status == 'active' ? 'text-positive' : ''"
              >
                {{ $t('globals.'+item.status) }} 
              </b>
            </template>
            <template v-slot:item.domain="{ item }">
              <b>
                <a
                  v-if="item.domain"
                  :href="'https://'+item.domain"
                  target="_blank"
                > {{ decodeDomain(item.domain) }} 
                  <v-icon>
                    mdi-arrow-top-right
                  </v-icon>
                </a>
                <a
                  v-else
                  :href="'https://'+item.subdomain+'.'+$ls.get('config').domain"
                  target="_blank"
                > {{ item.subdomain +'.'+ $ls.get("config").domain }} 
                  <v-icon>
                    mdi-arrow-top-right
                  </v-icon>
                </a>
              </b>
            </template>
            <template v-slot:item.created_at="{ item }">
              {{ item.created_at | moment("L") }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                v-if="item.status == 'active'"
                outlined
                text
                small
                :disabled="loading"
                @click="editWhiteLabel(item.uuid)"
              >
                {{ $t('globals.editButton') }}
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout
      v-if="!$apollo.loading && _.isEmpty(whiteLabels)"
      wrap
      justify-center
    >
      <helper-start-white-label />
    </v-layout>
  </v-container>
</template>

<script>

import USER_WHITELABELS_QUERY from '@/graphql/queries/WhiteLabels.gql';
import { mapGetters } from 'vuex'
import punycode from 'punycode/punycode';

export default {
  name: 'WhiteLabel',
  data() {
    return {
      datePicker: null,
      selectedId: null,
      dialog: false,
      loading: false,
      params: {},
      importFromDate: this.$moment().subtract(6, 'months').format('YYYY-MM-DD'),
      importSwitch: true,
      selectedItem: null,
      userProjects: [],
      headers: [
        {
          sortable: false,
          text: '',
          value: 'logo'
        },
        {
          sortable: false,
          text: this.$t('globals.name'),
          value: 'name'
        },
        {
          sortable: false,
          text: this.$t('whitelabel.domain'),
          value: 'domain'
        },
        {
          sortable: false,
          text: this.$t('globals.status'),
          value: 'status',
        },
          {
          sortable: false,
          text: this.$t('whitelabel.createdAt'),
          value: 'created_at',
        },
        {
          sortable: false,
          text: '',
          value: 'actions',
        },
      ]
    } 
  },
  computed: {
     ...mapGetters('user', ['getUser']),
     formatedImportFromDate() {
       return this.$moment(this.importFromDate).format('ll');
     }
  },
  methods: {
    addWhiteLabel() {
      this.$router.push('whitelabel/create')
    },
    decodeDomain(domain) {
      return punycode.toUnicode(domain)
    },
    editWhiteLabel (uuid) {
      this.selectedId = uuid
      this.$router.push({ 
          name: 'Edit White Label', 
          params: { uuid },
      })
    },
  },
  apollo: {
    whiteLabels: {
      query: USER_WHITELABELS_QUERY,
      variables() {
        return {
          owner_uuid: this.getUser.uuid
        }
      },
      skip() {
        return !this.getUser
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  h2 {
    display: inline-block;
  }
  .btn-project {
    float: right;
  }
  .v-avatar {
    margin: 10px 0;
  }
</style>
